// Header sidebar
document.addEventListener('DOMContentLoaded', function () {
    const sidebarMenu = document.querySelector('#sidebar-menu');

    sidebarMenu.addEventListener('dialog:after-show', () => {
        const accordionDetails = sidebarMenu.querySelectorAll('.accordion__disclosure');
        accordionDetails.forEach((detailsElement, index) => {
            detailsElement.setAttribute('open', '');
            detailsElement.setAttribute('aria-expanded', 'true');
        });
    });
});

// background open megamenu
const openedMegaMenus = document.querySelectorAll('.header_mega__menu-disclosure');
const menuBackgroundElements = document.querySelectorAll('.mega-menu-overlay');
const megaMenus = document.querySelectorAll('.mega-menu');

openedMegaMenus.forEach((openedMegaMenu, index) => {
    const menuBackgroundElement = menuBackgroundElements[index];
    const megaMenu = megaMenus[index];
    menuBackgroundElement.addEventListener('mouseenter', () => {
        if (openedMegaMenu.getAttribute('aria-expanded') === 'true' && openedMegaMenu.hasAttribute('open')) {
            openedMegaMenu.setAttribute('aria-expanded', 'false');
            openedMegaMenu.removeAttribute('open');
            megaMenu.style.opacity = '0';
        }
    });
});
